import React from 'react';
import Header from '../Header/header';
import Footer from "../Footer/footer"
import "./home.css"
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import Hero from '../Hero/Hero';
import Offerings from '../Offerings/Offerings';

function home() {
  document.title = "Tutors Gift";

  window.onscroll = function () {
    scrollFunction();
  };

  const scrollFunction = () => {
    const element = document.getElementById("back-to-top");
    if (element) {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        element.style.display = "block";
      } else {
        element.style.display = "none";
      }
    }
  };

  return (
    <React.Fragment>
      <div className="app">
     
        <Hero />
        <Offerings />
     
      </div>
    </React.Fragment>
  )
}

export default home
